/*
 * The platform admin's status page (UX-11) and the notices under every platform title: the
 * mockup's `.status-list` card, a card per section, its `.table`, and its `.notice` banners.
 */
.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  min-width: 0;
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.subtitle {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-4);
  min-width: 0;
}

/* The mockup's `.status-list .row`: the part on the left, its state and figures on the right. */
.statusList {
  margin: 0;
}

.statusList > .figure {
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2) var(--space-3);
  padding: var(--space-3) var(--space-4);
  border: 0;
  border-bottom: 1px solid var(--border);
  border-radius: 0;
  background: none;
}

.statusList > .figure:last-child {
  border-bottom: 0;
}

.statusList .term {
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  color: var(--text);
}

.statusList .value {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-2);
  font-size: var(--font-size-12);
}

.figures {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
  gap: var(--space-3);
  margin: 0;
}

.figure {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  background: var(--surface);
}

.term {
  font-size: var(--font-size-12);
  color: var(--text-muted);
}

.value {
  margin: 0;
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-semibold);
  font-variant-numeric: tabular-nums;
}

.muted {
  margin: 0;
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-regular);
  color: var(--text-muted);
}

.stale {
  margin: 0;
  font-size: var(--font-size-13);
  color: var(--warning-text);
}

.alarm {
  color: var(--danger-text);
}

.failing {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
  color: var(--danger-text);
}

.token {
  color: var(--text-muted);
  font-family: var(--font-mono);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-regular);
}

.scroll {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-13);
  font-variant-numeric: tabular-nums;
}

.table th,
.table td {
  padding: var(--space-2) var(--space-3);
  border-bottom: 1px solid var(--border);
  text-align: right;
  white-space: nowrap;
}

.table td {
  block-size: 48px;
}

.table thead th {
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
}

.table th[scope="row"],
.table thead th:first-child {
  text-align: left;
}

.table tbody th {
  font-weight: var(--font-weight-medium);
}

.table tbody tr:last-child th,
.table tbody tr:last-child td {
  border-bottom: 0;
}

.skeleton {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.skeletonRows {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

/* The mockup's `.notice`: a tinted banner with its glyph; the words carry the meaning, not the tone. */
.notices {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin-block-end: var(--space-4);
}

.notice {
  display: flex;
  gap: var(--space-2);
  align-items: flex-start;
  padding: 10px var(--space-3);
  border-radius: var(--radius-control);
  color: var(--text);
  font-size: var(--font-size-13);
}

.notice > svg {
  flex: none;
  margin-top: 2px;
}

.danger {
  background-color: var(--danger-surface);
}

.danger > svg {
  color: var(--danger-text);
}

.warning {
  background-color: var(--warning-surface);
}

.warning > svg {
  color: var(--warning-text);
}

.noticeTitle {
  margin: 0;
  font-weight: var(--font-weight-semibold);
}

.noticeBody {
  margin: 0;
}
